/**
 * Implement REST methods POST, GET, PUT, DELETE, PATCH
 * using the "fetch" API and mapping the api/v2 errors
 *  
 * @MAZ - 6-Abr-2020
 */
import API from './config.js';
import { Exception, queryStr, parseErrorMessage, encodeFormData } from './helpers';

export default {

  async get(endpoint, params) {
    /** 
     * GET method
     * 
     * @endpoint: the endpoint (without host etc)
     * @params: extra params to be sent in query str
     * @returns: a JSON obj or { error, message }
     * 
     * Use: get('/session', { include: 'user' })
     */
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    };

    if (API.token())
      options.headers['Authorization'] = API.token()

    let rsvp = await fetch(API.url(endpoint + queryStr(params)), options)

    if (rsvp.ok) {
      var response = await rsvp.json()
      return response
    }

    let err = await rsvp.text()
    throw (new Exception(rsvp.status, parseErrorMessage(err)))
  },

  async post(endpoint, data, params) {
    /** 
     * POST method
     * 
     * @endpoint: the endpoint (without host etc)
     * @data: the data object (NOT stringified)
     * @params: extra params to be sent in query str
     * @returns: a JSON obj or { error, message }
     * 
     * Use: post('/session', data, { include: 'user' })
     */
    const options = {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      }
    };

    if (API.token())
      options.headers['Authorization'] = API.token()

    let rsvp = await fetch(API.url(endpoint + queryStr(params)), options)

    if (rsvp.ok) {
      var response = await rsvp.json()
      return response
    }

    let err = await rsvp.text()
    throw (new Exception(rsvp.status, parseErrorMessage(err)))
  },


  async put(endpoint, data, params) {
    /** 
     * PUT method
     * 
     * @endpoint: the endpoint (without host etc)
     * @data: the data object (NOT stringified)
     * @params: extra params to be sent in query str
     * @returns: a JSON obj or { error, message }
     * 
     * Use: post('/session', data, { include: 'user' })
     */
    const options = {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      }
    };

    if (API.token())
      options.headers['Authorization'] = API.token()

    let rsvp = await fetch(API.url(endpoint + queryStr(params)), options)

    if (rsvp.ok) {
      var response = await rsvp.json()
      return response
    }

    let err = await rsvp.text()
    throw (new Exception(rsvp.status, parseErrorMessage(err)))
  },


  async delete(endpoint, params) {
    /** 
     * DELETE method
     * 
     * @endpoint: the endpoint (without host etc)
     * @params: extra params to be sent in query str
     * @returns: a JSON obj or { error, message }
     * 
     * Use: delete('/session', { include: 'user' })
     */
    const options = {
      method: 'DELETE',
      //body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
      }
    };

    if (API.token())
      options.headers['Authorization'] = API.token()

    let rsvp = await fetch(API.url(endpoint + queryStr(params)), options)

    if (rsvp.ok) {
      var response = await rsvp.json()
      return response
    }

    let err = await rsvp.text()
    throw (new Exception(rsvp.status, parseErrorMessage(err)))
  },


  async upload(endpoint, file, params) {
    /** 
     * UPLOAD FILE
     * 
     * @endpoint: the endpoint (without host etc)
     * @files: the files array (NOT stringified)
     * @params: extra params to be sent in query str
     * @returns: a JSON obj with metadata { uuid, name, type, full_name }
     * @exception: { error, message }
     * 
     * Use: post('/uploads', files, { record_uid: '1234' })
     */
    const formData = new FormData()
    formData.append('file_data', file)
    
    let rsvp = await fetch(API.url(endpoint + queryStr(params)), {
      method: 'POST',
      headers: {'Authorization': API.token()},
      body: formData
    });

    if (rsvp.ok) {
      var response = await rsvp.json()
      return response
    }

    let err = await rsvp.text()
    throw (new Exception(rsvp.status, parseErrorMessage(err)))
  },


  async syncronize(endpoint, data, params) {
    /**
     * Syncronizes with server using the old API v1.
     * Is a special case so we need a special function for it.
     */
    const options = {
      method: 'POST',
      body: encodeFormData(data),
      headers: {
        'Authorized': API.authorized(),
        'Content-Type': 'application/x-www-form-urlencoded"',
      }
    };

    const url = API.origin() + endpoint
    let rsvp = await fetch((url + queryStr(params)), options)

    if (rsvp.ok) {
      var response = await rsvp.json()
      return response
    }

    let err = await rsvp.text()
    throw (new Exception(rsvp.status, parseErrorMessage(err)))
  },

  Exception: Exception
}
